import { useState } from 'react';
import Pessoas from './Pessoas';
import Cargos from './Cargos';
import Squads from './Squads';
import CheckinSDR from './CheckinSDR';
import FilaRecebimento from './FilaRecebimento';
import MetasPontuacao from './MetasPontuacao';
import IntegracaoGHL from './IntegracaoGHL';

const TABS = [
    { id: 'pessoas',   label: 'Pessoas' },
    { id: 'cargos',    label: 'Cargos' },
    { id: 'squads',    label: 'Squads' },
    { id: 'checkin',   label: 'Check-in SDR' },
    { id: 'fila',      label: 'Fila de Recebimento' },
    { id: 'metas',     label: 'Metas' },
    { id: 'pontuacao', label: 'Pontuação' },
    { id: 'produtos',  label: 'Produtos' },
    { id: 'ghl',       label: 'Integração GHL' },
];

export default function Configuracoes() {
    const [activeTab, setActiveTab] = useState('pessoas');

    return (
        <>
            <div className="page-header">
                <div className="page-header-left">
                    <div>
                        <div className="page-kicker">Sistema</div>
                        <h1 className="page-title">Configurações</h1>
                    </div>
                </div>
            </div>

            {/* Tab bar — div simples, sem page-body (evita min-height: 100vh do CSS) */}
            <div style={{
                padding: '1rem 1.75rem',
                borderBottom: '1px solid var(--glass-border)',
                display: 'flex',
                gap: '0.375rem',
                flexWrap: 'wrap',
            }}>
                {TABS.map(tab => (
                    <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        style={{
                            padding: '0.375rem 0.875rem',
                            borderRadius: '0.4rem',
                            border: activeTab === tab.id
                                ? '1px solid var(--primary-color, #00dc82)'
                                : '1px solid rgba(255,255,255,0.08)',
                            background: activeTab === tab.id
                                ? 'rgba(0,220,130,0.08)'
                                : 'transparent',
                            color: activeTab === tab.id
                                ? 'var(--primary-color, #00dc82)'
                                : 'var(--text-secondary)',
                            fontSize: '0.8125rem',
                            fontWeight: activeTab === tab.id ? 600 : 400,
                            cursor: 'pointer',
                            transition: 'all 0.15s',
                        }}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Conteúdo — cada filho traz seu próprio page-body */}
            {activeTab === 'pessoas'   && <Pessoas embedded />}
            {activeTab === 'cargos'    && <Cargos />}
            {activeTab === 'squads'    && <Squads embedded />}
            {activeTab === 'checkin'   && <CheckinSDR embedded />}
            {activeTab === 'fila'      && <FilaRecebimento embedded />}
            {activeTab === 'metas'     && <MetasPontuacao embedded section="metas" />}
            {activeTab === 'pontuacao' && <MetasPontuacao embedded section="pontuacao" />}
            {activeTab === 'produtos'  && <MetasPontuacao embedded section="produtos" />}
            {activeTab === 'ghl'       && <IntegracaoGHL />}
        </>
    );
}
